import { Box, Button } from '@mui/material';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { LoadingButton } from '@mui/lab';
import { StyledButtonContainer, StyledConnectButton } from './ConnectButton.styles';

interface ConnectButtonProps {
  onClick: () => void;
  disabled: boolean;
  loading?: boolean;
}

const ConnectButton: React.FC<ConnectButtonProps> = ({ onClick, disabled, loading = false }) => {
  return (
    <StyledButtonContainer>
      <StyledConnectButton
        loading={loading}
        startIcon={<ExitToAppIcon/>}
        onClick={onClick}
        disabled={disabled}
      />
    </StyledButtonContainer>
  );
};

export default ConnectButton;